const navigation = () => {
  return [
    {
      "title": "Dashboard",
      "icon": "/images/navigation/dashboard.svg",
      "path": "/dashboard"
    },
    {
      "sectionTitle": "Basic"
    },
    {
      "title": "Photo",
      "icon": "/images/navigation/photo.svg",
      "path": "/photos",
      "category": "ALBUM_SUMMARY",
      "eventName": "Click_Photo"
    },
    {
      "title": "Video",
      "icon": "/images/navigation/video.svg",
      "path": "/video",
      "category": "ALBUM_DETAIL",
      "eventName": "Click_Video"
    },
    {
      "title": "GPS location",
      "icon": "/images/navigation/gps-location.svg",
      "path": "/locations/gps",
      "category": "LOCATION_DEVICES",
      "eventName": "Click_GPSlocation"
    },
    {
      "title": "Contact",
      "icon": "/images/navigation/contact.svg",
      "path": "/contacts",
      "category": "CONTACT",
      "eventName": "Click_Contact"
    },
    {
      "title": "Mail",
      "icon": "/images/navigation/mail.svg",
      "path": "/mail",
      "eventName": "Click_Mail"
    },
    {
      "title": "iCloud drive",
      "icon": "/images/navigation/icloud-drive.svg",
      "path": "/i-cloud-drive",
      "category": "ICLOUD_DRIVE_DIR",
      "eventName": "Click_iClouddrive"
    },
    {
      "title": "Note",
      "icon": "/images/navigation/note.svg",
      "path": "/notes",
      "category": "NOTE",
      "eventName": "Click_Note"
    },
    {
      "title": "Calendar",
      "icon": "/images/navigation/calendar.svg",
      "path": "/calendars",
      "category": "CALENDAR",
      "eventName": "Click_Calendar"
    },
    {
      "title": "Reminder",
      "icon": "/images/navigation/reminder.svg",
      "path": "/reminders",
      "category": "REMINDER_SUMMARY",
      "eventName": "Click_Reminder"
    },
    {
      "sectionTitle": "EXTREME"
    },
    {
      "title": "Text message",
      "icon": "/images/navigation/text-message.svg",
      "path": "/text-messages",
      "category": "SMS_CHAT_SUMMARY",
      "eventName": "Click_Textmessage"
    },
    {
      "title": "Call",
      "icon": "/images/navigation/call.svg",
      "path": "/calls",
      "category": "",
      "eventName": "Click_Call"
    },
    {
      "title": "Voicemail",
      "icon": "/images/navigation/voicemail.svg",
      "path": "/voicemail",
      "category": "",
      "eventName": "Click_Voicemail"
    },
    {
      "title": "WhatsApp",
      "icon": "/images/navigation/whatsapp.svg",
      "path": "/whatsapp",
      "category": "WHATSAPP_CHAT_SUMMARY",
      "eventName": "Click_WhatsApp"
    },
    {
      "title": "WA BUSINESS",
      "icon": "/images/navigation/wa-business.svg",
      "path": "/wa-business",
      "category": "WHATSAPP_CHAT_SUMMARY",
      "eventName": "Click_WABusiness"
    },
    {
      "title": "LINE",
      "icon": "/images/navigation/line.svg",
      "path": "/line",
      "category": "LINE_CHAT_SUMMARY",
      "eventName": "Click_LINE"
    },
    {
      "title": "Kik",
      "icon": "/images/navigation/kik.svg",
      "path": "/kik",
      "category": "KIK_CHAT_SUMMARY",
      "eventName": "Click_Kik"
    },
    {
      "title": "WeChat",
      "icon": "/images/navigation/wechat.svg",
      "path": "/we-chat",
      "category": "WECHAT_CHAT_SUMMARY",
      "eventName": "Click_WeChat"
    },
    {
      "title": "Messenger",
      "icon": "/images/navigation/messenger.svg",
      "path": "/messenger",
      "category": "FACEBOOK_MESSENGER_SUMMARY",
      "eventName": "Click_Messenger"
    },
    {
      "title": "Browser history",
      "icon": "/images/navigation/browser-history.svg",
      "path": "/browser-history",
      "category": "SAFARI_HISTORY",
      "eventName": "Click_Browserhistory"
    },
    {
      "title": "Browser bookmark",
      "icon": "/images/navigation/browser-bookmark.svg",
      "path": "/browser-bookmark",
      "category": "SAFARI_BOOKMARK",
      "eventName": "Click_Browserbookmark"
    },
    {
      "title": "Installed app",
      "icon": "/images/navigation/installed-app.svg",
      "path": "/apps",
      "category": "INSTALLED_APP",
      "eventName": "Click_Installedapp"
    },
    {
      "title": "Wi-Fi network",
      "icon": "/images/navigation/wi-fi-network.svg",
      "path": "/wifi-networks",
      "category": "WIFI",
      "eventName": "Click_Wifinetwork"
    },
    {
      "title": "Skype",
      "icon": "/images/navigation/skype.svg",
      "path": "/skype",
      "category": "skype",
      "eventName": "Click_Skype"
    },
    {
      "title": "Teams",
      "icon": "/images/navigation/teams.svg",
      "path": "/teams",
      "category": "Teams",
      "eventName": "Click_Teams"
    },
    {
      "title": "Telegram",
      "icon": "/images/navigation/telegram.svg",
      "path": "/telegram",
      "category": "Telegram",
      "eventName": "Click_Telegram"
    },
    {
      "title": "Snapchat",
      "icon": "/images/navigation/snapchat.svg",
      "path": "/snapchat",
      "category": "Snapchat",
      "eventName": "Click_Snapchat"
    },
    {
      "title": "Instagram",
      "icon": "/images/navigation/instagram.svg",
      "path": "/instagram",
      "category": "Instagram",
      "eventName": "Click_Instagram"
    },
    {
      "title": "Facetime",
      "icon": "/images/navigation/facetime.svg",
      "path": "/facetime",
      "category": "Facetime",
      "eventName": "Click_Facetime"
    },
    {
      "title": "My account",
      "icon": "/images/navigation/my-account.svg",
      "path": "/pages/account-settings/account",
      "eventName": "Click_Myaccount"
    }
  ]

}

export default navigation
